import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper, Table, TableContainer } from '@mui/material';
import Titlebar from '../TitleBar';
import {
  Pagination,
  SearchTable,
  TableBody4,
  TableBottom4,
  TableHeader,
} from '.';
import { applyFilter, getComparator } from '../../Utils/table';
import { AdminSaleMenu, onlyAdminSaleMenu } from '../TitleList';
import { selectStudentSaleData } from '../Selectors/Master/OutwardSelectors';
import { fetchStudentSaleData } from '../../Store/PHPSlice/stockApi';

const StudentSaleRegister = () => {
  const dispatch = useDispatch();
  const getItems = useSelector(selectStudentSaleData);
console.log("getItems=>",getItems);
  const userdata = JSON.parse(sessionStorage.getItem('user'));

  // Table state
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('srNo');
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageRange, setPageRange] = useState([0, 5]); // Page numbers visible
  const [activeMenu, setActiveMenu] = useState(AdminSaleMenu);

  // Fetch data
  useEffect(() => {
    dispatch(fetchStudentSaleData());
  }, [dispatch]);

  // Set menu based on user role
  useEffect(() => {
    if (!userdata) return;
    if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
      const pid = userdata?.pageIds?.find((item) => item === 1);
      if (pid === 1 && userdata?.role === '3') {
        setActiveMenu(onlyAdminSaleMenu);
      } else {
        setActiveMenu(AdminSaleMenu);
      }
    }
  }, []);

  if (!getItems) return <h1>Loading...</h1>;

  // Map API data
const compData = Array.isArray(getItems?.data)
  ? getItems.data.map((item, index) => ({
      srNo: item.ID,
      dt: item.dt,
      billNo: item.billNo,
      zoneId: item.zoneId || 0,
      zoneNm: item.zoneNm || '-',
      schlId: item.schlId || 0,
      schlNm: item.schlNm || '-',
      studNm: item.studNm || '-',
      totissqty: parseFloat(item.totissqty || 0),
      totamt: parseFloat(item.totamt || 0),
      serialNumber: index + 1,
    }))
  : [];
  console.log("getItems=>", getItems);
    console.log("comData=>",compData);

  // Sorting
  const handleSort = (event, id) => {
    const isAsc = orderBy === id && order === 'asc';
    if (id) {
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(id);
    }
  };

  // Selection
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = compData.map((n) => n.srNo);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, srNo) => {
    const selectedIndex = selected.indexOf(srNo);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, srNo);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  // Search
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredData = compData.filter(
    (item) =>
      item.billNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.zoneNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.schlNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.studNm.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Totals
  const totqty = filteredData.reduce((acc, item) => acc + item.totissqty, 0);
  const totamt = filteredData.reduce((acc, item) => acc + item.totamt, 0);

  // Apply sorting
  const dataFiltered = applyFilter({
    inputData: filteredData,
    comparator: getComparator(order, orderBy),
  });

  // Pagination
  const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
  const displayedData = dataFiltered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

  const handleNextPageRange = () => {
    setPageRange([
      Math.min(pageRange[0] + 5, totalPages - 5),
      Math.min(pageRange[1] + 5, totalPages),
    ]);
  };

  const handlePreviousPageRange = () => {
    setPageRange([Math.max(pageRange[0] - 5, 0), Math.max(pageRange[1] - 5, 5)]);
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <Titlebar data={activeMenu} />
      <div style={{ margin: '1% 0.5%' }}>
        <h2>Admin Student Sale Register</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper style={{ padding: '3vh', margin: 0 }}>
              <SearchTable
                handleItemsPerPageChange={handleItemsPerPageChange}
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                totalItems={filteredData.length}
              />

              <TableContainer
                style={{ marginTop: '2%', border: '1px solid #ccc' }}
              >
                <Table>
                  <TableHeader
                    headCells={[
                      { id: 'srNo', label: 'Sr.No' },
                      { id: 'dt', label: 'Date' },
                      { id: 'billNo', label: 'Bill No.' },
                      { id: 'zoneNm', label: 'Zone' },
                      { id: 'schlNm', label: 'School' },
                      { id: 'studNm', label: 'Student Name' },
                      { id: 'totissqty', label: 'Total Qty' },
                      { id: 'totamt', label: 'Total Amt.' },
                      { id: '', label: 'View' },
                      { id: 'edit', label: 'Edit' },
                      { id: 'add', label: 'Add Items' },
                      { id: 'delete', label: 'Delete' },
                    ]}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleSort}
                    numSelected={selected.length}
                    rowCount={compData.length}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <tbody>
                    {displayedData.map((row) => (
                      <TableBody4
                        key={row.srNo}
                        id={row.srNo}
                        dt={row.dt}
                        billNo={row.billNo}
                        zoneId={row.zoneId}
                        zoneNm={row.zoneNm}
                        schlId={row.schlId}
                        schlNm={row.schlNm}
                        studId={row.studId}
                        studNm={row.studNm}
                        totissqty={row.totissqty}
                        totamt={row.totamt}
                        serialNumber={row.serialNumber}
                        selected={selected.indexOf(row.srNo) !== -1}
                        handleClick={(event) => handleClick(event, row.srNo)}
                      />
                    ))}
                  </tbody>
                  <tfoot>
                    <TableBottom4 totamt={totamt} totqty={totqty} />
                  </tfoot>
                </Table>
              </TableContainer>

              <Pagination
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                handlePreviousPageRange={handlePreviousPageRange}
                visiblePageNumbers={visiblePageNumbers}
                pageNumber={pageNumbers}
                pageRange={pageRange}
                totalPages={totalPages}
                handleNextPageRange={handleNextPageRange}
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default StudentSaleRegister;
